import { profile } from '../lib/static-data';

export function Hero() {
  return (
    <section
      id="section-intro"
      className="section"
      style={{
        padding: '56px 28px 44px',
      }}
    >
      <div
        className="grid-hero"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 300px',
          gap: 48,
          alignItems: 'start',
        }}
      >
        <div>
          <div className="eyebrow" style={{ marginBottom: 28 }}>
            § 01 · Subject profile
          </div>
          <h1
            className="serif"
            style={{
              fontWeight: 400,
              fontSize: 'var(--fs-hero)',
              lineHeight: 0.9,
              letterSpacing: -3,
              margin: 0,
              marginBottom: 28,
            }}
          >
            Dan
            <br />
            <em>Merritts.</em>
          </h1>
          <p
            style={{
              fontSize: 14,
              maxWidth: 540,
              lineHeight: 1.7,
              marginBottom: 32,
              marginTop: 0,
            }}
          >
            Company builder. Nine ventures, seven exits over twenty-five years. Love bridging cultures through{' '}
            <span style={{ background: 'var(--accent)', color: 'var(--paper)', padding: '1px 7px' }}>
              travel and food
            </span>
            , with a side of{' '}
            <span style={{ background: 'var(--ink)', color: 'var(--paper)', padding: '1px 7px' }}>
              AI-innovation
            </span>
            .
          </p>

          <div
            className="stat-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              borderTop: '1px solid var(--ink)',
              borderBottom: '1px solid var(--ink)',
              maxWidth: 560,
            }}
          >
            {profile.stats.map(({ label, value }, i, a) => (
              <div
                key={label}
                style={{
                  borderRight: i < a.length - 1 ? '1px solid var(--ink)' : 'none',
                  padding: '12px 14px',
                }}
              >
                <div
                  style={{
                    fontSize: 10,
                    textTransform: 'uppercase',
                    opacity: 0.6,
                    letterSpacing: 0.5,
                  }}
                >
                  {label}
                </div>
                <div
                  className="serif"
                  style={{ fontSize: 36, marginTop: 2, lineHeight: 1 }}
                >
                  {value}
                </div>
              </div>
            ))}
          </div>

          <div
            style={{
              marginTop: 16,
              fontSize: 10.5,
              textTransform: 'uppercase',
              letterSpacing: 1.2,
              opacity: 0.7,
            }}
          >
            Residences · {profile.residences.join(' ✦ ')}
          </div>
        </div>

        <div>
          <div
            style={{
              fontSize: 10,
              textTransform: 'uppercase',
              letterSpacing: 1,
              marginBottom: 8,
              opacity: 0.6,
            }}
          >
            FIG. A · SUBJECT
          </div>
          <div
            style={{
              position: 'relative',
              width: '100%',
              aspectRatio: '3 / 4',
              background: 'var(--ink)',
              overflow: 'hidden',
            }}
          >
            <img
              src={profile.portrait.src}
              alt="Portrait of Dan Merritts"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                filter: 'contrast(1.04) saturate(0.95)',
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(transparent 62%, rgba(0,0,0,0.55))',
                pointerEvents: 'none',
              }}
            />
            <div
              style={{
                position: 'absolute',
                left: 10,
                top: 10,
                color: 'var(--paper)',
                fontSize: 9,
                textTransform: 'uppercase',
                letterSpacing: 1,
              }}
            >
              <span
                style={{
                  display: 'inline-block',
                  width: 6,
                  height: 6,
                  background: 'var(--accent)',
                  marginRight: 6,
                  borderRadius: '50%',
                }}
              />
              REC · 001
            </div>
            <div
              style={{
                position: 'absolute',
                left: 10,
                right: 10,
                bottom: 10,
                color: 'var(--paper)',
                fontSize: 9,
                textTransform: 'uppercase',
                letterSpacing: 0.8,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <span>DMERRITTS.JPG</span>
              <span>{profile.portrait.coords}</span>
            </div>
          </div>
          <div
            className="serif"
            style={{
              marginTop: 10,
              fontSize: 13,
              lineHeight: 1.5,
              opacity: 0.72,
              fontStyle: 'italic',
            }}
          >
            {'> '}The same Dan you'd meet over yakitori in Shinjuku. Warmer in person. Better with a question than an answer.
          </div>

          {/* Headshot downloads — high-res professional shots, 4429×5905. */}
          <div
            style={{
              marginTop: 14,
              paddingTop: 10,
              borderTop: '1px dotted var(--soft)',
              display: 'flex',
              gap: 12,
              alignItems: 'baseline',
            }}
          >
            <span
              style={{
                fontSize: 9,
                textTransform: 'uppercase',
                letterSpacing: 1.6,
                opacity: 0.55,
              }}
            >
              HEADSHOT
            </span>
            <a
              href="/assets/dan-bw.jpg"
              download="Dan_Merritts_headshot_bw.jpg"
              style={{
                fontSize: 10.5,
                textTransform: 'uppercase',
                letterSpacing: 0.8,
                color: 'var(--accent)',
                textDecoration: 'none',
                borderBottom: '1px solid var(--accent)',
                paddingBottom: 1,
              }}
            >
              ↓ B&amp;W
            </a>
            <a
              href="/assets/dan-color.jpg"
              download="Dan_Merritts_headshot_color.jpg"
              style={{
                fontSize: 10.5,
                textTransform: 'uppercase',
                letterSpacing: 0.8,
                color: 'var(--accent)',
                textDecoration: 'none',
                borderBottom: '1px solid var(--accent)',
                paddingBottom: 1,
              }}
            >
              ↓ Color
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
